import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import { loginAdmin } from '../../api/authApi';
import { useAuthStore } from '../../stores/authStore';

import logo from '../../assets/images/logo.png';
import '../../assets/css/Login.css';

const Login = () => {

  const navigate = useNavigate();

  const setAdmin = useAuthStore((state) => state.setAdmin);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passError, setPassError] = useState('');
  const [loginError, setLoginError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasError = false;
    if (!email.trim()) {
      setEmailError('Please enter email address');
      hasError = true;
    } else if (!emailPattern.test(email)) {
      setEmailError('Please enter valid email');
      hasError = true;
    } else {
      setEmailError('');
    }
    if (!password.trim()) {
      setPassError('Please enter password');
      hasError = true;
    } else {
      setPassError('');
    }
    if (hasError) return;

    try {
      setIsLoading(true);
      const res = await loginAdmin({ email, password });

      if (!res?.status && res?.status !== undefined) {
        setLoginError(res?.message)
      } else {
        navigate('/verify', { state: { email, password, rememberMe } });
      }
      setIsLoading(false)
    } catch (err) {
      setIsLoading(false)
      console.error("Login failed", err);
    }
  };

  return (
    <form className="form-design" onSubmit={handleSubmit} autoComplete="off">
      <section className="login">
        <div className="loginWindow">
          <div className="loginModel">
            <img src={logo} alt="Login" />
            <p className="loginTitle">Sign in to your account</p>
            <p className="loginSubtitle">Please enter your login details</p>
            <div className="name-field">
              <div className={`input-group ${email ? 'filled' : ''}`}>
                <input
                  type="text"
                  id="email"
                  className=""
                  name="email"
                  autoComplete="off"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError('');
                    setLoginError('')
                  }}
                />
                <label htmlFor="email">Email address</label>
              </div>
              {emailError && <p className="error-message">{emailError}</p>}
            </div>
            <div className="name-field">
              <div className={`input-group ${password ? 'filled' : ''}`}>
                <input
                  type="password"
                  id="password"
                  className=""
                  name="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPassError('');
                    setLoginError('')
                  }}
                />
                <label htmlFor="email">Password</label>
              </div>
              {passError && <p className="error-message">{passError}</p>}
            </div>
            {loginError && <p className="error-message">{loginError}</p>}
            <div className="loginInfo">
              <div>
                <input
                  type="checkbox"
                  id="loginCheckbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <label htmlFor="loginCheckbox">Remember for 30 days</label>
              </div>
            </div>
            <button
              className={`loginButton primary-button button ${isLoading ? 'btn_loading' : ''
                }`}
              type="submit"
            >
              {isLoading ? (
                <div className="registerLoader">
                  <div className="ring-loader"></div>
                </div>
              ) : (
                'Sign in'
              )}
            </button>
          </div>
        </div>
        <div className="pvivacy_mobile">
          <p>
            © Ivycon {new Date().getFullYear()}. All Rights Reserved.{' '}
            <span>Terms of Service</span> & <span>Privacy Policy</span>.
          </p>
        </div>
      </section>
    </form>
  );
};

export default Login;
